import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"


    
export default /*#__PURE__*/_defineComponent({
  __name: 'Image-wap',
  props: ['value'],
  setup(__props) {

    const img = __props;

return (_ctx: any,_cache: any) => {
  const _component_el_card = _resolveComponent("el-card")!

  return (typeof img.value === 'string')
    ? (_openBlock(), _createBlock(_component_el_card, {
        key: 0,
        class: "custom-card",
        "body-style": { padding: '0px' },
        style: _normalizeStyle({ backgroundImage: `url('${require(`@/assets/${img.value}`)}')` })
      }, null, 8, ["style"]))
    : _createCommentVNode("", true)
}
}

})